module.exports = __webpack_public_path__ + "img/Mapna.9eb374c.png";